export default __webpack_public_path__ + "static/media/pagination-1.8361f4df.svg";